/* global axios */
import { MetaAgentAPI } from './metaAgent';

// Click Agent do dia a dia (Plano 3): administrador e atendente, só leitura.
// Não há confirm/cancel/undo/uploads nesta rota — os métodos herdados que as usam
// nunca são chamados no modo office (o chat esconde anexo e cartão).
class OfficeClickAgentAPI extends MetaAgentAPI {
  constructor() {
    super('office/click_agent');
  }

  // GET /api/v2/accounts/:id/office/click_agent/config
  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  // PATCH /api/v2/accounts/:id/office/click_agent/config — só administrador
  updateConfig(body) {
    return axios.patch(`${this.url}/config`, body);
  }
}

export default new OfficeClickAgentAPI();
